import { IEventListItem } from 'schemas';
import { TEventListItem } from 'types';

import { getLogObject } from './getLogObject';
import { getLogSubject } from './getLogSubject';

export const getNormalizeLogs = (
  eventLists: IEventListItem[]
): Array<TEventListItem> =>
  eventLists.map(
    (
      {
        host,
        client,
        worker,
        description,
        timestamp,
        type,
        role,
        payment,
        comment,
        value1,
        value2,
        penalty,
        booking,
        hosts,
        tariff,
        cash_order,
        client_session,
        duration,
        combo,
        combo_items,
        discount,
        good,
        goods,
        host_group,
        new_devices,
        operator,
        role2,
        cash_on_start,
        promo_code_item,
        promo_campaign,
        service,
        host2,
        setting,
        user_group,
        user_group2,
        worker_task,
        host_command,
        cashback,
        payment_items,
        warehouse_item,
        additional_seconds,
        send_code_method,
        goods_category,
        additional_data,
        company_news_item,
        company_news_item_changes,
        deposit,
        shortcut,
        payment_transaction,
        manager,
        advertisement,
      },
      index
    ): TEventListItem => {
      const object = getLogObject({ type, worker, client, manager });
      const subject = getLogSubject({ type, worker, client, manager });

      return {
        description,
        id: index,
        subject,
        host: host ? host.title : undefined,
        type,
        timestamp,
        object,
        role: role ? role.title : undefined,
        role2: role2 ? role2.title : undefined,
        comment,
        payment,
        value1,
        value2,
        penalty,
        booking,
        hosts,
        tariff,
        cash_order,
        client_session,
        duration,
        combo,
        combo_items,
        discount,
        good,
        goods,
        host_group,
        new_devices,
        operator,
        cash_on_start,
        promo_code_item,
        promo_campaign,
        service,
        host2,
        client,
        setting,
        user_group,
        user_group2,
        worker_task,
        host_command,
        cashback,
        payment_items,
        warehouse_item,
        additional_seconds,
        send_code_method,
        goods_category,
        additional_data,
        company_news_item,
        company_news_item_changes,
        deposit,
        shortcut,
        payment_transaction,
        manager,
        advertisement,
      };
    }
  );
